<!-- nav -->
@if (currentUser) {
  <nav class="navbar nav navbar-expand-lg navbar-dark bg-primary px-2">
    <button
      class="navbar-toggler"
      type="button"
      (click)="isMenuCollapsed = !isMenuCollapsed">
      <img src="assets/burgericon.png" width="40" />
    </button>
    @if (isAdmin()) {
      <div>
        @for (notif of propNotifs; track notif) {
          <button
            class="navbar-toggler"
            type="button"
            (click)="viewNotifications(notif!.propid!)">
            <fa-icon class="m-icon" [icon]="faBell"></fa-icon>
            <span class="badge rounded-pill badge-notification bg-danger">{{notif!.notifications!}}</span>
          </button>
        }
      </div>
    }
    <button
      class="navbar-toggler"
      type="button"
      (click)="logout()">
      <fa-icon class="m-icon" [icon]="faArrowRightFromBracket"></fa-icon>
    </button>
    <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse" id="entraritNavDropdwn">
      <ul class="navbar-nav mx-auto">
        <li class="nav-item mx-2">
          <a class="nav-link nav-item" routerLink="/">
            Home
          </a>
        </li>
        <li class="nav-item mx-2">
          <!-- <a class="nav-item nav-link notification" (click)="checkNotifications()">
          <span>Messages</span>
          <span  *ngIf="messages" class="badge">1</span>
        </a> -->
        <a class="nav-item nav-link" routerLink="/available-properties/notices">
          Messages
        </a>
      </li>
      <li class="nav-item mx-2">
        <a class="nav-item nav-link" routerLink="/available-properties/operate">Open Gate</a>
      </li>
      <li class="nav-item mx-2">
        @if (isAdmin()) {
          <a class="nav-item nav-link" (click)="openAccessManagement()">Manage Users</a>
        }
      </li>
      <li class="nav-item mx-2">
        @if (isSuper()) {
          <a class="nav-item nav-link" routerLink="/user-profiles">User Profiles</a>
        }
      </li>
      @if (isSuper()) {
        <li class="nav-item mx-2">
          <a  class="nav-item nav-link" routerLink="/user-roles/list">User Roles</a>
        </li>
      }
      <li class="nav-item mx-2">
        @if (isAdmin()) {
          <a class="nav-item nav-link" (click)="openNumberManagement()">Manage Numbers</a>
        }
      </li>
      <li class="nav-item mx-2">
        @if (isAdmin()) {
          <a class="nav-item nav-link" routerLink="/manage-guest">Manage Guest</a>
        }
      </li>
      <li class="nav-item mx-2">
        @if (isAdmin()) {
          <a class="nav-item nav-link" routerLink="/manage-notices">Manage Notices</a>
        }
      </li>
      <li class="nav-item mx-2">
        @if (isAdmin()) {
          <a class="nav-item nav-link" (click)="openAccessLog()">Access Log</a>
        }
      </li>
      <li class="nav-item mx-2">
        <a class="nav-item nav-link" (click)="logout()">Logout</a>
      </li>
    </ul>
  </div>
</nav>
}
<!-- main app container -->
<div class="container">
  <router-outlet></router-outlet>
  <div class="container controls mt-2">
    @if (!noBackButton()) {
      <button type="button" (click)="goBack()" class="btn btn-primary">
        Back <fa-icon class="l-icon" [icon]="faArrowLeft"></fa-icon>
      </button>
    }
  </div>

</div>

<!-- credits -->
<div class="footer text-center mt-4">
  <!-- <p>
  <a href="https://stewartium.com/entrarit" target="_top">Entrarit</a>
</p> -->
<p>
  &copy; Stewartium 2020 - {{ currentYear }}
  <a href="https://stewartium.com/entrarit" target="_top">App Website </a> v{{VNUM}}
</p>
</div>
<!-- <div *ngIf="!message" class="alert alert-success mt-3 mb-0">{{ message | async | json }}</div> -->
<!-- {{ message | async | json }} -->
